import Phaser from 'phaser'
import { COLORS } from '../constants/game'

export default class BGPill extends Phaser.GameObjects.Container {
  constructor(scene, x, y, width) {
    super(scene, x, y, [])
    scene.add.existing(this)
    const bgpink = scene.add
      .image(-1, -1, 'pill-bg')
      .setOrigin(0, 0)
      .setTintFill(COLORS.primaryPink)
    const bgWhite = scene.add
      .image(0, 0, 'pill-bg')
      .setOrigin(0, 0)
      .setTintFill(0xffffff)

    bgpink.setDisplaySize(
      //  this.container.width - 10,
      width + 2,
      bgWhite.height + 2
    )
    bgWhite.setDisplaySize(
      //  this.container.width - 10,
      width,
      bgWhite.height
    )

    this.add([bgpink, bgWhite])
    this.setSize(bgWhite.displayWidth, bgWhite.displayHeight)
  }
}
